module.exports = "/shifts/components/filters/eventTypeOptions-b70fba.html";